var _path, _mask, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenShareOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0391 21.7849V39.7471H13.9622V21.7849C13.9622 20.8831 14.7198 20.152 15.6545 20.152H39.3468C40.2814 20.152 41.0391 20.8831 41.0391 21.7849Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_14325:18816",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5769 40.0872H44.4231V39.4069H10.5769V40.0872ZM13.9615 38.4543H41.0384V37.7739H13.9615V38.4543Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5769 40.0872H44.4231V39.4069H10.5769V40.0872ZM13.9615 38.4543H41.0384V37.7739H13.9615V38.4543Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5769 40.0872H9.0769V41.5872H10.5769V40.0872ZM44.4231 40.0872V41.5872H45.9231V40.0872H44.4231ZM44.4231 39.4069H45.9231V37.9069H44.4231V39.4069ZM10.5769 39.4069V37.9069H9.0769V39.4069H10.5769ZM13.9615 38.4543H12.4615V39.9543H13.9615V38.4543ZM41.0384 38.4543V39.9543H42.5384V38.4543H41.0384ZM41.0384 37.7739H42.5384V36.2739H41.0384V37.7739ZM13.9615 37.7739V36.2739H12.4615V37.7739H13.9615ZM10.5769 41.5872H44.4231V38.5872H10.5769V41.5872ZM45.9231 40.0872V39.4069H42.9231V40.0872H45.9231ZM44.4231 37.9069H10.5769V40.9069H44.4231V37.9069ZM9.0769 39.4069V40.0872H12.0769V39.4069H9.0769ZM13.9615 39.9543H41.0384V36.9543H13.9615V39.9543ZM42.5384 38.4543V37.7739H39.5384V38.4543H42.5384ZM41.0384 36.2739H13.9615V39.2739H41.0384V36.2739ZM12.4615 37.7739V38.4543H15.4615V37.7739H12.4615Z",
    fill: "white",
    mask: "url(#path-2-inside-1_14325:18816)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 29.1331V11.9873",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4236 16.0695L27.5005 11.1707L32.5774 16.0695",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27.5C54 42.1355 42.1355 54 27.5 54C12.8645 54 1 42.1355 1 27.5C1 12.8645 12.8645 1 27.5 1C42.1355 1 54 12.8645 54 27.5Z",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShareOff);
export default __webpack_public_path__ + "static/media/screen-share-off.6a5971ed.svg";
export { ForwardRef as ReactComponent };